module.exports = __webpack_public_path__ + "img/13.8152d9d1.svg";